import { type EventResult } from '~/domain/events/models/event-result';
import { cn } from '~/styles/extended-theme';

interface AddressProps {
  className?: string;
  location: EventResult['location'];
}

export function EventAddress({
  className,
  location: { name, addressLine1, addressLine2, city, stateAbbreviation, zip },
}: AddressProps) {
  return (
    <div className={cn('text-body1', className)}>
      {name ? <div>{name}</div> : null}
      <div className="capitalize">{addressLine1}</div>
      {addressLine2 ? <div className="capitalize">{addressLine2}</div> : null}
      <div>
        {city}, {stateAbbreviation} {zip}
      </div>
    </div>
  );
}
